import validate from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/node_modules/.pnpm/nuxt@3.19.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler_37e8c2ab4e677a5a11de1ffa5820ba05/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/middleware/auth.global.ts";
import redirection_45global from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/middleware/redirection.global.ts";
import utm_45global from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/middleware/utm.global.ts";
import manifest_45route_45rule from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/node_modules/.pnpm/nuxt@3.19.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler_37e8c2ab4e677a5a11de1ffa5820ba05/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  redirection_45global,
  utm_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}